export default "__VITE_ASSET__CvIfHXDz__"